"use strict";

exports.__esModule = true;
exports.calculatePictureHeight = exports.getArticleUrl = exports.WIDGET_LINK_TYPE = exports.getArticleMeta = exports.getArticleDate = exports.formatDate = void 0;

var tslib_1 = require("tslib");

var format_1 = tslib_1.__importDefault(require("date-fns/format"));

var isToday_1 = tslib_1.__importDefault(require("date-fns/isToday"));

var isYesterday_1 = tslib_1.__importDefault(require("date-fns/isYesterday"));

var parseISO_1 = tslib_1.__importDefault(require("date-fns/parseISO"));
/**
 *
 * @param {string|Date} date
 */


exports.formatDate = function (date) {
  var d = Object.prototype.toString.call(date) === '[object Date]' // https://stackoverflow.com/a/643827
  ? date : parseISO_1["default"](date);

  if (isToday_1["default"](d)) {
    return 'Dnes';
  }

  if (isYesterday_1["default"](d)) {
    return 'Včera';
  }

  return format_1["default"](d, 'd.L.Y');
};

exports.getArticleDate = function (article) {
  return article.modified ? article.modified : article.date;
};

exports.getArticleMeta = function (article) {
  if (article.author && typeof article.author.name === 'string') {
    return exports.formatDate(exports.getArticleDate(article)) + " | " + article.author.name.toLocaleUpperCase();
  }

  return exports.formatDate(exports.getArticleDate(article));
};

exports.WIDGET_LINK_TYPE = {
  ARTICLE_DETAIL: 'article_detail',
  ARTICLE_FILTER: 'article_filter',
  SECTION_DETAIL: 'section_detail'
};

exports.getArticleUrl = function (article) {
  if (!article) {
    throw Error('Not article specified');
  }

  if (article.redirect) {
    return article.redirect;
  }

  if (article.url) {
    return "/" + article.url;
  }

  return "/article/" + article._id;
};

exports.calculatePictureHeight = function (width, aspectRatioWidth, aspectRatioHeight) {
  return Math.round(width * aspectRatioHeight / aspectRatioWidth);
};